import React from 'react';
import AdminLayout from '../components/AdminLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { CatalogSongsTab } from '../components/catalog/CatalogSongsTab';
import { CatalogPlaylistsTab } from '../components/catalog/CatalogPlaylistsTab';

/**
 * Super-admin Music Catalog — the licensed-song database and its playlists.
 * Scaffolding for the future licensed local player: upload/manage songs and
 * build playlists from them. Playback wiring comes in a later turn.
 */
export default function AdminCatalogPage() {
  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto space-y-6">
        <header>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#39FF14] font-bold">Super Admin</p>
          <h1 className="text-3xl font-extrabold tracking-tight mt-1">Music Catalog</h1>
          <p className="text-sm text-gray-400 mt-1">
            Your central database of licensed songs. Upload tracks, tag them, and group them into playlists.
          </p>
        </header>

        <Tabs defaultValue="songs" className="w-full">
          <TabsList className="bg-white/[0.04] border border-white/10" data-testid="catalog-tabs">
            <TabsTrigger value="songs" data-testid="tab-songs">Songs</TabsTrigger>
            <TabsTrigger value="playlists" data-testid="tab-playlists">Playlists</TabsTrigger>
          </TabsList>
          <TabsContent value="songs" className="mt-5">
            <CatalogSongsTab />
          </TabsContent>
          <TabsContent value="playlists" className="mt-5">
            <CatalogPlaylistsTab />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
}
